import styled from 'styled-components';

export const QualityContent = styled.main`
  height: 66.3vh;
  margin: 16px 0;
  padding-top: 10px;
  overflow-y: scroll;
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey2} !important;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top-left-radius: 6px;
`;

export const RatingColumn = styled.div`
  width: 25%;
  justify-content: center;
`;

export const RatingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20%;
  h4 {
    margin-bottom: 20px;
  }
`;
